<template>
  <TabPanel value="personalize">
    <FeatureCard
      span="2"
      title="Make your bio link your own"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom
        >Customize your bio link to match your brand and personality.
      </VText>

      <FeatureCardList component="ol">
        <li>18 ready to use themes</li>
        <li>4 Pro themes <Badge content="Pro" /></li>
        <li>1000+ fonts</li>
        <li>4000+ icons for your links</li>
        <li>Create your own custom theme</li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/personalize.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
